import React, {useState} from 'react';
import BtnSvg from "./BtnSvg";

// Composant ModalInfos
const ModalInfos = ({titre = "Informations", children = "Voici le contenu de la modale."}) => {
    const [isOpen, setIsOpen] = useState(false);

    const ouvrirModal = () => setIsOpen(true);
    const fermerModal = () => setIsOpen(false);

    return (
        <div style={styles.contenant}>
            {/* Icône cliquable */}
            <BtnSvg svg={"aide"} width={20} height={20} onClick={ouvrirModal} couleur={"#70787B"}/>

            {/* Modale */}
            {isOpen && (
                <div style={styles.modal}>
                    <BtnSvg style={styles.fermer} svg={"croix"} width={20} height={20} onClick={fermerModal}/>
                    <div style={styles.titre}>{titre}</div>
                    <div>{children}</div>
                    <div style={styles.triangle}></div>
                </div>
            )}
        </div>
    );
};

// Styles
const styles = {
    contenant: {
        position: 'relative',
        display: 'inline-block',
    },
    modal: {
        position: 'absolute',
        bottom: 'calc(100% + 10px)',
        left: '50%',
        transform: 'translateX(-50%)',
        backgroundColor: '#fff',
        borderRadius: '50px 50px 50px 2px',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        padding: '15px 30px',
        zIndex: 1000,
        border: '1px solid #000',
        fontSize: "12px",
        width: 'auto', // Permet à la modale de s'adapter au contenu
        maxWidth: 'none', // Supprime une éventuelle largeur maximale
        overflow: 'visible', // S'assure que rien n'est masqué
    },
    titre: {
        marginBottom: '8px',
        fontWeight: 'bold',
        fontSize: "14px"
    },
    fermer: {
        position: 'absolute',
        top: '8px',
        right: '30px',
        cursor: 'pointer',
    },
};
export default ModalInfos;
